import { useCallback } from 'react'

import { useUploadFile } from '@/api/storage'

import type { GraphicItem } from '@/context/brand-context'

export function useUploadGraphics() {
  const { mutateAsync: uploadFile } = useUploadFile()

  return useCallback(
    async (items: GraphicItem[]): Promise<string[]> => {
      const urls: string[] = []

      for (const graphic of items) {
        if (graphic.file) {
          const url = await uploadFile(graphic.file)
          urls.push(url)
        }
      }

      return urls
    },
    [uploadFile]
  )
}
